import { LocationStatCollection } from 'app/shared/collections/location_stat_collection.service';
import { ImsObjectIncrementalCollection } from './ims_object_incremental_collection.service';
import { AssetResource } from '../resources';
import { Asset } from './asset';
import TagCollection from 'app/shared/collections/tag_collection.service';
import { AssetTypeCollection } from 'app/shared/collections/asset_type_collection.service';
import { ViewStateService } from 'app/shared/view_state.service';
import { IIntervalService, IRootScopeService } from 'angular';
import {
    CollectionCRUDResult,
    ImsObjectCollectionOptions,
} from 'app/shared/collections/ims_object_collection.service';
import { IntegrationCollection } from './integration_collection.service';
import { SiteStateService } from '../site_state.service';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';

export class AssetCollection extends ImsObjectIncrementalCollection<Asset> {
    private _locationStatCollection: LocationStatCollection;

    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $rootScope: IRootScopeService,
        $interval: IIntervalService,
        viewStateService: ViewStateService,
        siteStateService: SiteStateService,
        assetTypeCollection: AssetTypeCollection,
        tagCollection: TagCollection,
        integrationCollection: IntegrationCollection,
        options?: ImsObjectCollectionOptions,
    ) {
        super(
            startUpRegistry,
            localStorageService,
            $rootScope,
            $interval,
            viewStateService,
            siteStateService,
            AssetResource,
            Asset,
            options,
        );

        if (assetTypeCollection) {
            this.defineRelationship('type', null, 'type_id', assetTypeCollection);
        }
        if (tagCollection) {
            this.defineRelationship('tags', null, 'tags', tagCollection);
        }
        if (integrationCollection) {
            this.defineRelationship('integrations', 'asset_id', null, integrationCollection);
        }
    }

    public setLocationStatCollection(locationStatCollection: LocationStatCollection): void {
        this._locationStatCollection = locationStatCollection;
    }

    async addObjectOffline(imsObject: Asset): Promise<CollectionCRUDResult<Asset>> {
        const result = await super.addObjectOffline(imsObject);

        // the api has the ability to save a location stat at the same time as creating an asset
        //  if that happens - we'll get back the saved location stat in the response - and it'll have
        //  the location stat id.
        const hasInitialLocationWithId = result.obj?.initialLocation?.id > 0;
        if (hasInitialLocationWithId) {
            // if we get our location stat - push it through the location stat collection
            //  so the app can show the location immediately
            const location = result.obj.initialLocation;
            const changed = this._locationStatCollection._processResources([location]);
            const origin = this._locationStatCollection.constructor.name;
            await this._locationStatCollection.collectionChanged(changed, origin);
        }
        return result;
    }

    refreshData(params = {}, checkTime = false, useInFlightCheck = false) {
        return super.refreshData(
            {
                // we only include the ip devices ids inside the asset request if we have an ip device collection to knit
                // them together with.. otherwise there's no point... THE PRESENCE OF THIS QUERY PARAM IS USED BY
                // THE MOBILE SERVICE WORKER TO CACHE THE ASSET REQUEST
                site_id: this._siteStateService.selectedSiteId,
            },
            checkTime,
            useInFlightCheck,
        );
    }
}
